import React, { useState, useEffect } from 'react';
import './AdminAuth.css';

const AdminAuth = ({ onAuthenticated }) => {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [attempts, setAttempts] = useState(0);

  // Admin password - in production, this should be in environment variables
  const ADMIN_PASSWORD = 'admin123';

  useEffect(() => {
    // Check if already authenticated
    const isAuth = localStorage.getItem('admin_authenticated');
    console.log('🔐 Admin auth check:', { isAuth, password: ADMIN_PASSWORD });
    if (isAuth === 'true') {
      onAuthenticated();
    }
  }, [onAuthenticated]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 500));

    if (password === ADMIN_PASSWORD) {
      localStorage.setItem('admin_authenticated', 'true');
      onAuthenticated();
    } else {
      setAttempts(prev => prev + 1);
      setError(`Invalid password. Attempts: ${attempts + 1}/5`);
      
      if (attempts >= 4) {
        setError('Too many failed attempts. Please refresh the page.');
        setPassword('');
        return;
      }
    }
    
    setIsLoading(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_authenticated');
    window.location.reload();
  };

  return (
    <div className="admin-auth-container">
      <div className="admin-auth-card">
        <div className="admin-auth-header">
          <h1>🔐 Admin Access</h1>
          <p>Enter password to access event management</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-auth-form">
          <div className="form-group">
            <label htmlFor="password">Admin Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              required
              disabled={isLoading}
              className={error ? 'error' : ''}
              autoComplete="current-password"
              autoFocus
              style={{ 
                position: 'relative',
                zIndex: 10,
                pointerEvents: 'auto'
              }}
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button 
            type="submit" 
            disabled={isLoading || password.length === 0}
            className="admin-login-btn"
          >
            {isLoading ? 'Authenticating...' : 'Access Admin Panel'}
          </button>
        </form>

        <div className="admin-auth-footer">
          <p>🔒 Secure admin access for event management</p>
        </div>
      </div>
    </div>
  );
};

export default AdminAuth;
